import { ICreateSeries, ISeriesPrototype } from '@/types/series.types';
import { Post } from '../helpers';
import { SeriesPath } from './path';

export default function CreateSeries(series: ICreateSeries) {
  return Post<ISeriesPrototype>({
    path: SeriesPath(series.channel),
    body: series,
  });
}
